// Marco de las pantallas sin sesión (acceso, olvidé mi contraseña, elegir la contraseña y el celular): la marca arriba
// y el formulario en una hoja que sube desde abajo en el celular; en tablet o notebook, una tarjeta centrada.
import { cx, Icono } from '@reparto/ui';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Lo que una pantalla de acceso le deja a la otra al ir (el correo ya escrito). */
export interface EstadoAcceso {
  email?: string;
}

/** Enlace chico de abajo (la guía de uso, entrar con el celular), con 44 px de alto para tocarlo. */
export function EnlacePie({
  a,
  icono,
  estado,
  children,
}: {
  a: string;
  icono: string;
  estado?: EstadoAcceso;
  children: ReactNode;
}) {
  return (
    <Link
      to={a}
      state={estado}
      className="flex min-h-11 items-center justify-center gap-1.5 px-2 text-sm text-stone-600 hover:text-primary-700 dark:text-stone-400 dark:hover:text-primary-300"
    >
      <Icono nombre={icono} tamano={18} />
      {children}
    </Link>
  );
}

export function MarcoAcceso({ children, compacto }: { children: ReactNode; compacto?: boolean }) {
  return (
    <div className="seguro-arriba flex min-h-full flex-col bg-gradient-to-b from-primary-800 to-primary-950 text-white sm:items-center sm:justify-center sm:px-6">
      <div className="flex flex-1 flex-col sm:my-10 sm:w-full sm:max-w-md sm:flex-none">
        <div className={cx('px-6 sm:px-2 sm:pt-0', compacto ? 'pt-8 pb-6' : 'pt-12 pb-7')}>
          {compacto ? (
            <div className="flex items-center gap-3">
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-white/15">
                <Icono nombre="local_shipping" tamano={26} relleno />
              </span>
              <span className="text-xl font-bold">Reparto</span>
            </div>
          ) : (
            <>
              <span className="grid h-16 w-16 place-items-center rounded-2xl bg-white/15">
                <Icono nombre="local_shipping" tamano={36} relleno />
              </span>
              <h1 className="mt-5 text-3xl font-bold">Reparto</h1>
              <p className="mt-1 text-primary-100">Tu ruta del día, aunque no haya señal.</p>
            </>
          )}
        </div>
        <div className="flex-1 rounded-t-4xl bg-stone-50 px-6 pt-8 pb-10 text-stone-900 sm:flex-none sm:rounded-4xl sm:px-8 sm:pb-8 sm:shadow-2xl dark:bg-stone-950 dark:text-stone-100">
          {children}
        </div>
      </div>
    </div>
  );
}

/** Aviso de error dentro del formulario (rojo suave, legible en claro y en oscuro). */
export function AvisoError({ children }: { children: ReactNode }) {
  return (
    <p
      role="alert"
      className="flex items-start gap-2 rounded-2xl bg-rose-50 px-4 py-3 text-sm text-rose-800 dark:bg-rose-950/50 dark:text-rose-200"
    >
      <Icono nombre="error" tamano={18} className="mt-px shrink-0" />
      <span>{children}</span>
    </p>
  );
}

/** Lo que solo pasa en la demostración con datos simulados (el código o el enlace que llegaría). */
export function AvisoDemostracion({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-2xl bg-amber-100 px-4 py-3 text-sm text-amber-900 dark:bg-amber-900/40 dark:text-amber-100">
      {children}
    </div>
  );
}

/** Separador "o" entre la contraseña y los proveedores. */
export function SeparadorO() {
  return (
    <div className="flex items-center gap-3 text-sm text-stone-500 dark:text-stone-400" aria-hidden="true">
      <span className="h-px flex-1 bg-stone-200 dark:bg-stone-800" />o
      <span className="h-px flex-1 bg-stone-200 dark:bg-stone-800" />
    </div>
  );
}
